import { dispatcher, IEvent, ingenuity } from "@quest/base-core";
import { Main, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { SlotEventConstants } from "@quest/slot-core";
import { eventDispatchers } from "./Constants/EventDispatchers";
import { TopBarViewGame } from "./TopBar/TopBarViewGame";
import { TopBarControllerGame } from "./TopBar/TopBarControllerGame";
import { GameParserModel } from "./Platform/GameParserModel";
import { gameConstants } from "./Constants/gameConstants";

export class MainGame extends Main {
  constructor(mainDiv = SlotConstantsBehavior.GAMECONTENT, deviceConfig?: any, loadStateObj?: any) {
    super(mainDiv, deviceConfig, loadStateObj);
    //to resolve button hit area in mobile issue
    if (ingenuity.deviceEnv.getDeviceOS() === "ios" || ingenuity.deviceEnv.getDeviceOS() === "macos") {
      if (document.getElementById("gameBody")) {
        document.getElementById("gameBody").style.width = "100%";
        document.getElementById("gameBody").style.height = "100%";
        document.getElementById("gameBody").style.position = "fixed";
      }
    }
  }

  /**
   * to store correct stakeat the time of
   */
  protected openGame(evt: IEvent): void {
    super.openGame(evt);
    dispatcher.fireEvent(SlotEventConstants.LOGIC_ONSTAKE_CHANGE);
  }

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.RESIZE_CANVAS, this.onSizeChange, this);
  }

  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.RESIZE_CANVAS, this.onSizeChange, this);
  }

  protected initializeTopBar() {
    const view = new TopBarViewGame(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).topBar);
    new TopBarControllerGame(view);
    ingenuity.currentGame.stage.addChild(view);
  }
  protected initializeBottomBar() {
    //
  }

  protected handleHelpRTP(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsRTPShown()) {
      const rtpValue = document.getElementById("rtpValue");
      rtpValue.textContent = String((ingenuity.parserModel as GameParserModel).getGameRTP());
      const maxRTP = document.getElementById("rtpMaxValue");
      maxRTP.textContent = String((ingenuity.parserModel as GameParserModel).getMaxGameRTP());
      const minRTP = document.getElementById("rtpMinValue");
      minRTP.textContent = String((ingenuity.parserModel as GameParserModel).getMinGameRTP());
    } else {
      const rtpSection = document.getElementById("rtpSection");
      rtpSection.style.display = "none";
      const maxrtpSection = document.getElementById("maxrtpSection");
      maxrtpSection.style.display = "none";
      const minrtpSection = document.getElementById("minrtpSection");
      minrtpSection.style.display = "none";
    }
  }

  protected onAssetsLoaded(evt: IEvent): void {
    
    super.onAssetsLoaded(evt);
    if ((ingenuity.parserModel as GameParserModel).getLanguage() === gameConstants.BSPOT_LANG) {
      ingenuity.configData.isBSPOTEnable = true;
    }
  }
}
